import { Link } from "react-router-dom";
import { newsList, sortEntries } from "@/utils/content";

export default function NewsDigest() {
  const sorted = sortEntries(newsList, "release");
  const feature = sorted[0];
  const rest = sorted.slice(1, 5);

  if (!feature) return null;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
      <Link
        to={`/detail/${feature.id}`}
        className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
      >
        <div className="w-full aspect-[16/9] overflow-hidden bg-background-200">
          <img
            src={feature.image}
            alt={feature.title}
            title={`${feature.title} 影视工厂资讯`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="p-5 md:p-6">
          <span className="inline-block px-2 py-0.5 rounded text-xs bg-accent-100 text-accent-900">
            {feature.genres[0]}
          </span>
          <h3 className="mt-3 text-lg md:text-xl font-medium text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {feature.title}
          </h3>
          <p className="mt-2 text-sm text-foreground-600 line-clamp-2">{feature.summary}</p>
          <p className="mt-4 text-xs text-foreground-500 flex items-center gap-1">
            <i className="ri-time-line" />
            {feature.releaseDate}
          </p>
        </div>
      </Link>

      <div className="flex flex-col gap-3">
        {rest.map((item, index) => (
          <Link
            key={item.id}
            to={`/detail/${item.id}`}
            className="group flex items-start gap-4 rounded-lg bg-background-50 border border-background-200 p-4 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span className="w-9 h-9 shrink-0 rounded-md bg-background-100 text-foreground-500 flex items-center justify-center font-heading text-lg group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              {index + 1}
            </span>
            <div className="min-w-0">
              <h4 className="text-sm md:text-base font-medium text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h4>
              <p className="mt-1.5 text-xs text-foreground-500 flex items-center gap-3">
                <span className="flex items-center gap-1">
                  <i className="ri-price-tag-3-line" />
                  {item.genres[0]}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line" />
                  {item.releaseDate}
                </span>
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}